import { createFileRoute } from "@tanstack/react-router";
import { TenderDetailsPage } from "@/pages/tender-details";
import { searchParams } from "@/pages/tender-details/model/search-params";
import { ErrorHandler } from "@/shared/ui/error-handling/ui/error-handler";
import {
  preloadTenderDetailQuery,
  preloadTenderShellQuery,
} from "@/entities/tender/api/fetch-tender-query";
import { preloadReviewableViewsQuery } from "@/entities/view/api/fetch-reviewable-views-query";
import { preloadCompanyWorkflowsQuery } from "@/features/workflow-dropdown";

const TenderDetailsRoute = () => {
  return (
    <>
      <TenderDetailsPage />
    </>
  );
};

export const Route = createFileRoute(
  "/_authed/$companySlug/tenders/$tenderId/",
)({
  component: TenderDetailsRoute,
  validateSearch: searchParams,
  loader: ({ context, params }) => {
    // company is guaranteed by $companySlug beforeLoad redirect guard
    if (context.company) {
      // Fire the detail query and the side-panel queries together at navigation
      // time so they run in parallel. Without this the side panel's queries only
      // start after the detail query's suspense resolves, adding a serial wave.
      void preloadTenderShellQuery(context.company.id, params.tenderId);
      void preloadTenderDetailQuery(context.company.id, params.tenderId);
      void preloadReviewableViewsQuery(context.company.id, params.tenderId);
      void preloadCompanyWorkflowsQuery(context.company.id);
    }
  },
  errorComponent: ({ error }) => <ErrorHandler error={error} />,
});
